import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { ClientDepartmentStateClass } from "./interfaces/ClientDepartmentStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";


const initialState: ClientDepartmentStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    clientDepartmentList: []
}

interface IThunkApi {
    state: {
        clientDepartment: ClientDepartmentStateClass
    }
}

export const getAccountEmployeeTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "EmployeeTypes/v2/getAccountEmployeeType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const getClientDepartmentsByAccountPartyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/getClientDepartmentsByAccountPartyId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientDepartment/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
    export const getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentId",
        async (arg, thunkApi) => {
            //const { AccountPartyDepartmentId, ...argWithoutId } = arg;
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientDepartment/PartyDepartmentById/" + arg , "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
    

export const addAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/addAccountClientDepartment",
        async (arg, thunkApi) => {
            // const response = await fetchAPI("api/EmployeeTypes/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientDepartment/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/updateAccountClientDepartment",
        async (arg, thunkApi) => {
            const { AccountPartyDepartmentId, ...argWithoutId } = arg;
            //const response = await fetchAPI("api/EmployeeTypes/"+AccountEmployeeTypeId,"POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientDepartment/" + AccountPartyDepartmentId, "PUT", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/deleteAccountClientDepartment",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientDepartment/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const DeleteSelectedAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/DeleteSelectedAccountClientDepartment",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ClientDepartment/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

const clientDepartmentSlice = createSlice({
    name: "clientDepartment",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.clientDepartmentList.findIndex((item) => item.AccountPartyDepartmentId == action.payload);
            const newArray = [...state.clientDepartmentList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.clientDepartmentList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.clientDepartmentList.findIndex((item) => item.AccountPartyDepartmentId == action.payload);
            const newArray = [...state.clientDepartmentList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.clientDepartmentList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.clientDepartmentList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.clientDepartmentList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.clientDepartmentList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.clientDepartmentList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountEmployeeTypeAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {

                // state.status = "idle";
                // //state.employeeTypeList = payload;
                // if (Object.keys(payload.Data).length === 0) {
                //     // Handle the case where payload.Data is empty or an empty object
                //     state.clientDepartmentList = [];
                // } else {
                //     state.clientDepartmentList = payload.Data;
                //     state.clientDepartmentList.map((item: any) => {
                //         item.isSelected = 0
                //     });
                // }
                // state.isReload = false;
                // state.isLoading = false;
                // state.selectedRecord = {};
            })
            .addCase(getAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = "failed";
            })

            .addCase(getClientDepartmentsByAccountPartyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getClientDepartmentsByAccountPartyIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                //state.employeeTypeList = payload;
                console.log('payload.Data:',payload.Data);
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.clientDepartmentList = [];
                } else {
                    state.clientDepartmentList = payload.Data;
                    state.clientDepartmentList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
                
            })
            .addCase(getClientDepartmentsByAccountPartyIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                //state.employeeTypeList = payload;
                
                
                if (Object.keys(payload.Data[0]).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    console.log('payload.Data:',payload.Data[0]);
                    state.selectedRecord = payload.Data[0];
                }

                state.isReload = false;
                state.isLoading = false;
                
                
            })
            .addCase(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                console.log('payload add:', payload);

            })
            .addCase(addAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                console.log('payload update:', payload);

            })
            .addCase(updateAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(DeleteSelectedAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
               // console.log('deleteselected', payload);
            })
            .addCase(DeleteSelectedAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState } = clientDepartmentSlice.actions
export const ClientDepartmentState = (state: RootState) => state.clientDepartment
export default clientDepartmentSlice.reducer


